<template>
  <v-btn
    elevation="0"
    color="#fff"
    class="font-weight-bolder btn-outline-default py-4 px-8"
    :class="width ? width : 'w-100'"
    :disabled="!disabled"
    @click="btnBlueClicked"
    small
  >
    {{ btnTitle }}
  </v-btn>
</template>

<script>
export default {
  name: "BtnWhite",
  props: {
    btnTitle: {
      type: [String, Number],
      default: "BTN TITLE",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [String, null],
      default: null,
    },
  },

  methods: {
    btnBlueClicked() {
      this.$emit("clicked");
    },
  },
};
</script>

<style scoped></style>
